import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Checkbox,
  FormGroup,
  Typography,
  Button,
  FormControl,
  Box,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import { handleValidationForm } from "utils/utils";
import BootstrapInput from "./CommonFormStyle";
import Loader from "components/loader/Loader";
import ErrorMessage from "components/error/ErrorMessage";
import profile from "assets/images/SubVendorLogo.svg";
import verified from "assets/images/verified.svg";

export default function CommonForm(props) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({ defaultValues: props?.defaultValues, mode: "onChange" });
  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(
    props?.selectType === "edit" ? false : true
  );
  const formData = props?.formData ? props?.formData : [];
  // ---Country Code---
  const [country, setCountry] = useState("+91");
  const [image, setImage] = useState(null);
  const [facilities, setFacilities] = useState(
    props?.defaultValues?.facilities || []
  );
  const [selectedGender, setSelectedGender] = useState("");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleInput = (e, value,name) => {
    clearErrors(e.target.name);
    let data = {};
    if (value && value !== undefined) {
      data[e.target.name] = value;
    } else {
      data[e.target.name] = e.target.value;
    }
    let validationData = handleValidationForm(data, selectedGender);
    setFormError(validationData?.errorVal);

    if(props?.selectType === 'edit'){ 
      props?.onHandleInput(e,name);
    }
  };
  const onClickGender = (value) => {
    setSelectedGender(value);
  };
  const handleCheckboxChange = () => {
    setIsCheckboxChecked((prevValue) => !prevValue);
    setIsDisabled(!isDisabled);
  };

  const handleAuto = (e, value) => {
    setFacilities(value);
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };

  const handleEditIconClick = (id) => {
    props.handleEditIconClick(id);
  };

  // ---Form Validation---

  const onSubmit = (data) => {
    // handleValidationForm
    let validationData;
    const genderPresent = formData.some((e) => e.name === "gender");
    if (genderPresent) {
      validationData = handleValidationForm({
        ...data,
        gender: selectedGender,
      });
      setFormError(validationData.errorVal);
    } else {
      validationData = handleValidationForm(data);
      setFormError(validationData.errorVal);
    }

    if (validationData.formIsValid) {
      if (facilities?.length > 0) {
        const val = { ...data, facilities: facilities?.map((list) => list.id) };
        props.onSubmittBtn(val, country);
      } else {
        data.check = isCheckboxChecked;
        if (genderPresent) {
          props?.onSubmittBtn({ ...data, gender: selectedGender, country });
        } else {
          props.onSubmittBtn(data, country);
        }
      }
    }
  };

  const handleClose = () => {
    props.onHandleClose();
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImage(URL.createObjectURL(img));
    }
  };

  const handleOnError = (e) => {
    e.target.src = profile;
  };
  return (
    <div>
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}
        >
          {formData?.map((ele, idx) => (
            <div>
              {(
                  <Box className={idx === formData?.length - 1 ? 'boxOutline' : 'length'}
                    key={ele?.name}
                  >
                    <FormControl variant="standard" className="width100">
                      <p className="commonformLabel">
                        {ele?.label}
                        {(ele?.required || ele?.starVal) && (
                          <span className="colorRed">{ele?.star || "*"}</span>
                        )}
                      </p>
                      <Box className='dflex'>
                        {ele?.countrycode && (
                          <FormControl
                            className="border width100 countryCode"
                          >
                            <Select
                              className="borderRadius10"
                              value={country ? country : "+91"}
                              onChange={handleChange}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem className="colorBlack" value={"+91"}>
                                +91
                              </MenuItem>
                            </Select>
                          </FormControl>
                        )}
                        <FormControl fullWidth className="commonFormControl spacingLeft">
                          {ele?.options ? (
                            <Select
                              {...register(ele?.name, {
                                required: ele?.required || false,
                              })}
                              onChange={(e) => handleInput(e)}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <InputLabel
                                disabled
                                className="colorGrey marginLeft16"
                              >
                                {ele.placeholder}
                              </InputLabel>
                              {ele?.options.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : ele?.fullName ? (
                            <Grid container justifyContent="space-between">
                              {ele?.fullName?.map((fn) => (
                                <Grid item md={5.5} xs={12}>
                                  <p className="commonformLabel">
                                    {fn?.label}
                                    {(fn?.required || fn?.starVal) && (
                                      <span className="colorRed">
                                        {fn?.star || "*"}
                                      </span>
                                    )}
                                  </p>
                                  <BootstrapInput
                                    placeholder={fn?.placeholder}
                                    {...register(fn?.name, {
                                      required: fn?.required || false,
                                      onChange: (e) => {
                                        handleInput(e);
                                      },
                                    })}
                                    type={fn?.type}
                                    inputProps={{
                                      maxLength: fn?.maxlength, 
                                     }}         
                                    id="bootstrap-input"
                                    error={
                                      errors[fn?.name] || formError[fn?.name]
                                    }
                                  />
                                  {errors[fn?.name] && (
                                    <ErrorMessage icon={false} errorMessage= {'This field is required'} />
                                  )}
                                  {formError[fn?.name] && (
                                     <ErrorMessage icon={false} errorMessage={formError[fn?.name]} />
                                  )}
                                </Grid>
                              ))}
                            </Grid>
                          ) : ele?.profile ? (
                            <Grid container xs={12} justifyContent="space-between">
                            {ele?.profile?.map((item,index) => (
                              <Grid item sm={5.5} xs={12} key={index}>
                                <p className="commonformLabel">
                                  {item?.label}
                                  {(item?.required || item?.starVal) && (
                                    <span className="colorRed marginRight6">
                                      {item?.star || "*"}
                                    </span>
                                  )}
                                  {item?.verify && props?.verify[item?.name]   && <img  src={verified} alt='verified'/> } 
                                </p>
                                <Box className='dflex' md={12}>
                          {item?.countryCode &&(
                              <FormControl
                                className="border width100 countryCode"
                               >
                            <Select
                              className="borderRadius10"
                              value={country || "+91"}
                              disabled={item?.disabled || false}
                              onChange={handleChange}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem className="colorBlack" value={"+91"}>
                                +91
                              </MenuItem>
                            </Select>
                          </FormControl>
                        )}
                                <BootstrapInput
                                className="width100"
                                placeholder={item?.placeholder}
                                  {...register(item?.name, {
                                    required: item?.required || false,
                                    onChange: (e) => {
                                      handleInput(e,'',item?.name);
                                    },
                                  })}
                                  type={item?.type}
                                  disabled={item?.disabled}
                                  inputProps={{
                                    maxLength: item?.maxlength, 
                                   }}         
                                  id="bootstrap-input"
                                  error={
                                    errors[item?.name] || formError[item?.name]
                                  }
                                /></Box>
                                {errors[item?.name] && (
                                  <ErrorMessage icon={false} errorMessage= {'This field is required'} />
                                )}
                                {formError[item?.name] && (
                                   <ErrorMessage icon={false} errorMessage={formError[item?.name]} />
                                )}
                              </Grid>
                            ))}
                          </Grid>
                          ) : ele?.type === "checkbox" ? (
                            <FormGroup
                              className="filterBox dfDirectionRow"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    id="agreeCheckbox"
                                    disabled={props?.disabled}
                                    checked={isCheckboxChecked}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label={
                                  ele?.content ? (
                                    <Typography className="font12 fw400 colorGrey">
                                      {ele?.content}
                                      <a
                                        href={"/termsandconditions"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="colorPrimary"
                                      >
                                        {ele?.link}
                                      </a>
                                    </Typography>
                                  ) : (
                                    <Typography className="font12 colorBlack fw400">
                                      I have read and agree to the&nbsp;<a
                                        href={"/privacy-policy"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="colorPrimary"
                                      >privacy policy
                                      </a>&nbsp;and&nbsp;<a
                                        href={"/termsandconditions"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="colorPrimary"
                                      >
                                        terms of services, and conditions
                                      </a>
                                    </Typography>
                                  )
                                }
                              />
                            </FormGroup>
                          ) : ele?.button ? (
                            <>
                              <Grid container
                              direction="row"
                              justifyContent="space-between">
                                {ele?.button?.map((btn) => (
                                  <Grid
                                    item
                                    md={2.5} xs={12}
                                    key={btn?.name}
                                  >
                                    <Button
                                      className={"genderFont"}
                                      onClick={() => onClickGender(btn?.name)}
                                    >
                                      <Grid item className="marginRight10">
                                        <img
                                          className="wh33"
                                          src={
                                            selectedGender === btn?.name
                                              ? btn?.activeImg
                                              : btn?.image
                                          }
                                          alt={btn?.name}
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        className={
                                          selectedGender === btn?.name
                                            ? "genderFont colorBlue"
                                            : "genderFont"
                                        }
                                      >
                                        {btn?.label}
                                      </Grid>
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>
                            </>
                          ) : (
                            <BootstrapInput
                              placeholder={ele?.placeholder}
                              {...register(ele?.name, {
                                required: ele?.required || false,
                                onChange: (e) => {
                                  handleInput(e);
                                },
                              })}
                              type={ele?.type}
                                inputProps={{
                                  maxLength: ele?.maxlength,
                                  className:"noSpinner"
                                 }}
                              id="bootstrap-input"
                              error={errors[ele?.name] || formError[ele?.name]}
                              disabled={
                                ele?.editProps && props?.editIconId === ele?.id
                                  ? false
                                  : ele?.disabled || false
                              }
                              multiline={ele?.multiline || false}
                              rows={ele?.row || ""}
                              defaultValue={ele?.defaultValue}
                              endAdornment={
                                <InputAdornment
                                 className="margin0"
                                  position="start"
                                >
                                  {ele?.disabled &&
                                    ele?.disabled === true &&
                                    !ele?.editProps && (
                                      <IconButton className="editIconCommon cursorAuto"></IconButton>
                                    )}
                                </InputAdornment>
                              }
                            />
                          )}
                          {}
                        </FormControl>
                        {ele?.editProps && props?.editIconId === ele?.id ? (
                          <Box>
                            <Grid
                              container
                              xs={12}
                              className="verifyButtonAlign"
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className={`mt0 ${
                                    isDisabled ? "verifyDisabled" : "verifyBtn"
                                  }`}
                                  type="verify"
                                  fullWidth
                                  disabled={isDisabled}
                                >
                                  Verify
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className="cancelButton"
                                  type="cancel"
                                  fullWidth
                                  onClick={() => handleEditIconClick("")}
                                >
                                  Cancel
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        ) : null}
                      </Box>
                      {/* errors will return when field validation fails  */}
                      {errors[ele?.name] && (
                        <ErrorMessage icon={false} errorMessage={'This field is required'} />
                      )}
                      {formError[ele?.name] && (
                         <ErrorMessage icon={false} errorMessage= {formError[ele?.name]}/>
                      )}
                      {props?.locationError && (
                        <div className="colorRed">{props?.locationError}</div>
                      )}
                    </FormControl>
                  </Box>
                )} 
            </div>
          ))}
          {props?.button &&
            props?.button !== "dialogButton" &&
            props?.button !== "Confirm and pay now" && (
              <Box>
                <Grid container>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      size="medium"
                      className={`buttonSubmit ${
                        props?.button === "Sign Up" && isDisabled
                          ? "buttonDisabled"
                          : ""
                      }`}
                      type="submit"
                      fullWidth
                      disabled={
                        props?.button === "Sign Up" ? isDisabled : !isDisabled
                      } // Disable button if no form field value is present
                    >
                      {props.loading ? <Loader /> : props?.button}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          {props?.button === "Confirm and pay now" &&
            props?.button !== "dialogButton" && (
              <Box>
                <Grid container>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      size="medium"
                      className={`buttonEnabled ${
                        isDisabled ? "buttonDisabled" : ""
                      }`}
                      type="submit"
                      fullWidth
                      disabled={
                        props?.button === "Confirm and pay now"
                          ? isDisabled
                          : !isDisabled
                      } // Disable button if no form field value is present
                    >
                      {props.loading ? <Loader /> : props?.button}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          {props?.button && props?.button === "dialogButton" && (
            <Box className='justifyEnd'>
              <Grid container
              justifyContent='space-between' className="btnDialogContainer" md={props?.size}>
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => 
                      handleClose()
                    }
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className={`primaryBtn width100`}
                    type="submit"
                    fullWidth
                  >
                    {props?.selectType === "edit"
                      ? "Update"
                      : props?.selectType === "Send"
                      ? "Send"
                      : "Create"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </form>
      </div>
    </div>
  );
}
